import flowPagePlugin from './flowPagePlugin';

export const allBuiltinPagePluginInfoList = [
  flowPagePlugin,
];
